export type { AnswerSlideProps } from "./AnswerSlide";
export { AnswerSlide, default } from "./AnswerSlide";
